import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { rgba } from 'polished';
import { color, spacing } from '../../style/theme';
import imageUrl from '../../utils/imageUrl';
import Link from '../Link';
import slug from '../../utils/slug';
import PlaceholderImage from '../../img/placeholder-image.svg';
import { ReactComponent as CloseIcon } from '../../img/icon-x.svg';
var ListItem = styled.div.withConfig({
  displayName: "ProductListItem__ListItem",
  componentId: "kws6iz-0"
})(["display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid ", ";"], rgba('#c7ced6', 0.5));
var ListItemQty = styled.div.withConfig({
  displayName: "ProductListItem__ListItemQty",
  componentId: "kws6iz-1"
})(["margin-right:", "px;"], spacing.base);
var ListItemRemove = styled.div.withConfig({
  displayName: "ProductListItem__ListItemRemove",
  componentId: "kws6iz-2"
})(["margin-left:", "px;"], spacing.base);
var LinkStyled = styled(Link).withConfig({
  displayName: "ProductListItem__LinkStyled",
  componentId: "kws6iz-3"
})(["display:flex;align-items:center;flex-grow:1;text-decoration:none;padding:", "px 0;"], spacing.quarter);
var Input = styled.input.withConfig({
  displayName: "ProductListItem__Input",
  componentId: "kws6iz-4"
})(["width:", "px;padding-left:", "px;"], spacing.base * 2, spacing.quarter);
var Remove = styled.div.withConfig({
  displayName: "ProductListItem__Remove",
  componentId: "kws6iz-5"
})(["width:40px;height:40px;display:flex;align-items:center;justify-content:center;fill:", ";transition:fill 0.3s ease;cursor:pointer;&:hover{fill:", ";}"], rgba(color.secondary1, 0.5), rgba(color.primaryRed, 1));
var TextInfo = styled.div.withConfig({
  displayName: "ProductListItem__TextInfo",
  componentId: "kws6iz-6"
})(["display:flex;flex-direction:column;", ":hover &{text-decoration:underline;}"], LinkStyled);
var Pill = styled.span.withConfig({
  displayName: "ProductListItem__Pill",
  componentId: "kws6iz-7"
})(["background-color:", ";border-radius:200px;padding:3px ", "px;color:white;font-size:", "px;font-weight:bold;text-align:center;@media only screen and (max-width:750px){padding:1px ", "px;}"], color.primaryBlue, spacing.base, spacing.halve, spacing.halve);
var ProductName = styled.h4.withConfig({
  displayName: "ProductListItem__ProductName",
  componentId: "kws6iz-8"
})(["padding-left:", "px;padding-right:", "px;margin-bottom:", "px;"], spacing.base, spacing.base, spacing.base * 0.3);
var ProductIdentifiers = styled.p.withConfig({
  displayName: "ProductListItem__ProductIdentifiers",
  componentId: "kws6iz-9"
})(["padding-left:", "px;padding-right:", "px;margin-bottom:0;"], spacing.base, spacing.base);
var PlaceholderImg = styled.div.withConfig({
  displayName: "ProductListItem__PlaceholderImg",
  componentId: "kws6iz-10"
})(["width:75px;height:75px;background-image:url(", ");background-size:contain;background-repeat:no-repeat;background-position:center;"], PlaceholderImage);

var getSubTitleString = function getSubTitleString(product) {
  return product.productFields ? product.productFields.reduce(function (accumulator, field) {
    if (product.internal_identifiers.includes(field.value)) {
      accumulator.push(field.label + ": " + field.value);
    }

    return accumulator;
  }, []).join(', ') : '';
};

var ProductListItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ProductListItem, _React$Component);

  function ProductListItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          product = _this$props.product,
          manufacturer = _this$props.manufacturer,
          listPagePath = _this$props.listPagePath,
          _onClick = _this$props.onClick,
          quantity = _this$props.quantity,
          onEditQuantity = _this$props.onEditQuantity;
      return React.createElement(ListItem, null, onEditQuantity && quantity && React.createElement(ListItemQty, null, React.createElement(Input, {
        required: true,
        type: "number",
        min: "1",
        disabled: _this.props.product.unique,
        value: _this.props.product.__quantity,
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
        },
        onChange: function onChange(e) {
          onEditQuantity(parseInt(e.target.value, 10));
        }
      })), React.createElement(LinkStyled, {
        onClick: function onClick(event) {
          if (_onClick) {
            event.preventDefault();

            _onClick(event);
          }
        },
        to: !_onClick ? "/" + slug(manufacturer) + "/" + slug(product.id.split('-')[0] + '-' + product.name) + "/" : '/#',
        state: !_onClick ? {
          isModal: true,
          listPagePath: listPagePath
        } : undefined
      }, !!product.images.length && React.createElement("div", {
        style: {
          maxWidth: '100px'
        }
      }, typeof product.images[0] === 'string' && React.createElement("img", {
        src: imageUrl(product.images[0], 75),
        srcSet: imageUrl(product.images[0], 75) + " 1x, " + imageUrl(product.images[0], 150) + " 2x",
        alt: "Thumbnail image of the " + product.manufacturer + " " + product.name
      }), typeof product.images[0] !== 'string' && React.createElement(Img, {
        style: {
          width: '75px',
          height: '75px'
        },
        imgStyle: {
          objectFit: 'contain'
        },
        fixed: product.images[0].localImage.childImageSharp.fixed,
        alt: "Thumbnail image of the " + product.manufacturer + " " + product.name
      })), !product.images.length && React.createElement(PlaceholderImg, null), React.createElement(TextInfo, null, React.createElement(ProductName, null, product.name), React.createElement(ProductIdentifiers, null, getSubTitleString(product)))), React.createElement("div", null, React.createElement(Pill, null, manufacturer.replace(/ /g, '\xa0'))), onEditQuantity && React.createElement(ListItemRemove, null, React.createElement(Remove, {
        onClick: function onClick(event) {
          event.stopPropagation();
          event.preventDefault();
          onEditQuantity(0);
        }
      }, React.createElement(CloseIcon, {
        style: {
          width: '1.4rem',
          height: '1.4rem'
        },
        title: "Remove"
      }))));
    });

    return _this;
  }

  return ProductListItem;
}(React.Component);

export default ProductListItem;